module.exports = __webpack_public_path__ + "img/Weapon_195.07351854.png";